<template>
    <div class="canvas">
        <el-row class="canvas-title mt-60" :gutter="30">
            <el-col :span="5">
                <div :class="tabFlg==='1'?'item2':'item3'" @click="tabChange('1')">协会动态<img class="icon" src="../../assets/images/gain-jt.png"></div>
            </el-col>
            <el-col :span="4">
                <div :class="tabFlg==='2'?'item2':'item3'" @click="tabChange('2')">通知公告</div>
            </el-col>
            <el-col :span="15">
                <div class="text-right" @click="goHome">返回首页<img src="../../assets/images/fanhui.svg" alt="" /></div>
            </el-col>
        </el-row>
        <ImgInfoList v-if="tabFlg==='1'" :list="list" @handleDetail="jumpDocInfo" />
        <div class="canvas-out mt-30" v-if="tabFlg === '2'">
            <div v-for="item, index in list" :key="index" class="canvas-out-for www">
                <el-row>
                    <el-col :span="18">
                        <el-collapse v-model="activeNames" @change="getDocInfo(item)">
                            <el-collapse-item :name="index">                              
                                <template slot="title">
                                    <div style="margin-right: 20px; width: 120px; color: #8B8B8B;">{{item.showDate?item.showDate.substring(0, 10):''}}</div>                            
                                    <div style="text-align: left;width: 90%;"><span style="text-align: left" class="line1">{{item.title}}</span></div>
                                </template>
                                <div v-html="item.content"></div>
                            </el-collapse-item>
                        </el-collapse>
                    </el-col>
                    <el-col :span="6">
                        <div style="line-height: 45px; cursor:pointer" @click="jumpDocInfo(item.docId, 2)">查看详情>></div> 
                    </el-col>
                </el-row>              
            </div>
        </div>
        <div class="page mb-40 mt-40">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="param.pageIndex"
                :page-size="param.pageSize"
                :page-sizes="[10, 15, 20, 30]"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total">
            </el-pagination>
        </div>
    </div>
</template>
<script>
import {
    getAssociationDynamicListApi,
    getNoticeAnnouncementListApi,
    getDocBaseInfoByIdApi
} from "@/api"
import ImgInfoList from '@/components/ImgInfoList/ImgInfoList'
export default {
    components:{
        ImgInfoList
    },
    data () {
        return {
            list:[],
            total:0,
            param:{
                pageIndex:1,
                pageSize:10,
            },
            tabFlg:'1',
            activeNames: [],
            flag:true,
        }
    },
    watch: {
        $route: {
            handler: function(val){
                this.tabFlg = val.query.tab
                this.getlist(this.param, val.query.tab)
            }
        }
    },
    created(){
        this.tabFlg = this.$route.query.tab?this.$route.query.tab:'1'
        this.getlist(this.param, this.tabFlg)
    },
    methods: {
        async getlist(param, flg){
            let returnList = []
            if (flg === '1') {//协会动态
                const { data } = await getAssociationDynamicListApi(param)
                if(data){
                    this.total = data.count
                    if (data.list){
                        data.list.forEach(item => {
                            let info = {
                                docId: item.doc_id,
                                title: item.association_title,
                                content: item.association_content,
                                showDate: item.showDate
                            }
                            returnList.push(info)
                        })
                    }
                    this.list = returnList
                }
            } else {//通知公告
                const { data } = await getNoticeAnnouncementListApi(param)
                if(data){
                    this.total = data.count
                    if (data.list){
                        data.list.forEach(item => {
                            let info = {
                                docId: item.doc_id,
                                title: item.notice_title,
                                content: item.notice_content,
                                showDate: item.showDate
                            }
                            returnList.push(info)
                        })
                    }
                    this.list = returnList
                }
            }
        },
        async getDocInfo(item){
            var docid = item.docId
            console.log(item.docId)
            if (!item.isActive) {
                item.isActive = !item.isActive
                const { data } = await getDocBaseInfoByIdApi({
                    doc_id: docid,
                    pageIndex:this.pageIndex,
                    pageSize:this.pageSize
                })
                // if (data.docBase) {
                //     document.getElementById(docid).innerHTML = data.docBase.doc_content
                // }
            }
        },
        replaceImg(info) {
            if (info) {
                let content
                content = info.replace(/<img .*?>/g,"");//去除图片在列表中显示
                return content
            }
        },
        jumpDocInfo(docId, tab){
            var position = '/AssociationWork?tab='+(tab?tab:1)
            this.$router.push({
                path: '/DetailsPage',
                query: {
                    docId: docId,
                    position: position,
                    positionName: '协会工作'
                }
            }, () => {})
        },
        tabChange(flg){
            this.tabFlg = flg            
            this.getlist(this.param, flg)
        },
        handleSizeChange(val){
            this.$set(this.param, 'pageSize', val)
            this.getlist(this.param, this.tabFlg)
        },
        handleCurrentChange(val){
            this.activeNames = []
            this.$set(this.param, 'pageIndex', val)
            this.getlist(this.param, this.tabFlg)
        },
        goHome(){
            this.$router.push({
            path: '/home'
            }, () => {})
        }
    }
}
</script>

<style lang="scss" scoped>
@import './AssociationWork.scss';
</style>
<style lang="scss">
 .www{
    width: 100%;
    .el-collapse {
        border-bottom: 0;
    }
    .el-collapse-item__header{
        font-size: 18px;
    }
    .el-collapse-item__wrap{
        border-bottom: none;
    }
    .el-collapse-item__arrow {width: 40px;}
    .el-icon-arrow-right:before {font-size:25px; content: "＋";}
    .el-collapse-item__arrow.is-active {font-size:25px; transform: none;}
    .el-collapse-item__arrow.is-active:before {font-size:25px; content: "－";}
 }
</style>
